import React, { useEffect, useState } from "react";
// import Footer from "../../Kryzen Alpha App/Components//Footer/footer";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import DynamicFilterInput from "../../../Components/layouts/filter.inpit";
import getFilteredURL from "../../../Components/Functions/filters.getUrl";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import Pagination from "../../../Components/layouts/pagination";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import SIschedulesTables from "./view_si_schedules_table";
import { FcKindle } from "react-icons/fc";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
const SiSchedules = () => {
  const [refresh, setRefresh] = useState(false);
  let userData = useSelector((store) => store.login.user);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
    generatedBy: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);
  const [generatedBy, setGeneratedBy] = useState([]);

  useEffect(() => {
    if (
      userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
      userData?.Role === process.env.REACT_APP_ROLE_ADMIN ||
      userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN
    ) {
      setLoading(true);
      performRequest(
        "GET",
        getFilteredURL(
          "/bookSiteInspection/getSiteInspectionSchedules/",
          page,
          filters
        )
      )
        .then((res) => {
          if (res.status === 200) {
            setData(res?.data?.bookSiteInspectionData);

            setTotalPages(Math.ceil(res?.data?.bookSiteInspectionCount / 50));
          } else {
            Toast("error", "Error while getting Data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    } else if (
      userData?.Role === process.env.REACT_APP_ROLE_SALLE ||
      userData?.Role === process.env.REACT_APP_ROLE_SALLE_ADMIN
    ) {
      filters.generatedBy = userData?.UserId;
      setLoading(true);
      performRequest(
        "GET",
        getFilteredURL(
          "/bookSiteInspection/getSiteInspectionSchedules/",
          page,
          filters
        )
      )
        .then((res) => {
          if (res.status === 200) {
            setData(res?.data?.bookSiteInspectionData);

            setTotalPages(Math.ceil(res?.data?.bookSiteInspectionCount / 50));
          } else {
            Toast("error", "Error while getting Data!");
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        })
        .finally(() => setLoading(false));
    }
  }, [refresh, page]);

  useEffect(() => {
    performRequest("GET", "/leads/getAllLeadsOwners")
      .then((res) => {
        setGeneratedBy(Array.isArray(res?.data) ? res.data : []); // Ensure it's always an array
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div style={{ minHeight: "80vh" }}>
          <div className="page-header d-print-none">
            <div className="container-xl">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title">
                    <FcKindle className="fs-2  me-1" />
                    SI Schedules
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>

                <div className="col-auto ms-auto d-print-none">
                  <div className="d-flex d-none d-sm-block gap-3">
                    <button
                      className="btn btn-primary me-2"
                      onClick={() =>
                        (window.location.href =
                          "/schedule-site-inspection-by-sales")
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M12 5l0 14" />
                        <path d="M5 12l14 0" />
                      </svg>
                      New SI Schedule
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="container-xxl">
              <div className="row">
                <div className="col-md-3 col-sm-12 py-2">
                  <div className="card p-2">
                    <div
                      id="faq-1"
                      className="accordion"
                      role="tablist"
                      aria-multiselectable="true"
                    >
                      <div>
                        <div className="accordion-header m-0" role="tab">
                          <button
                            className="accordion-button fs-3 d-md-none p-0"
                            data-bs-toggle="collapse"
                            data-bs-target="#faq-1-1"
                          >
                            <h3 className="m-1">Filter result</h3>
                          </button>
                        </div>

                        <div
                          id="faq-1-1"
                          className="accordion-collapse collapse d-md-none"
                          role="tabpanel"
                          data-bs-parent="#faq-1"
                        >
                          <div className="accordion-body pt-0">
                            <div className="row">
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Start Date:"
                                  value={filters.startdate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      startdate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="End Date:"
                                  value={filters.enddate}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      enddate: e.target.value,
                                    })
                                  }
                                  type="date"
                                />
                              </div>
                              <div className="col-12">
                                <DynamicFilterInput
                                  label="Search name/phone/orderId/email:"
                                  value={filters.name}
                                  onChange={(e) =>
                                    setFilters({
                                      ...filters,
                                      name: e.target.value,
                                    })
                                  }
                                  placeholder="search name..."
                                />
                              </div>

                              {(userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <div className="col-12">
                                    <DynamicFilterSelect
                                      label="Status:"
                                      onChange={(e) =>
                                        setFilters({
                                          ...filters,
                                          status: e.target.value,
                                        })
                                      }
                                      value={filters.status}
                                    >
                                      <option value="">select all</option>
                                      <option value="upcomingInspection">
                                        Upcoming Inspection
                                      </option>
                                      <option value="requestedSI">
                                        Requested SI Schedules
                                      </option>
                                      <option value="siteInspectionCompleted">
                                        Completed Site Inspection
                                      </option>
                                    </DynamicFilterSelect>
                                  </div>
                                </div>
                              )}
                              {(userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN_S ||
                                userData?.Role ===
                                  process.env.REACT_APP_ROLE_ADMIN) && (
                                <div className="col-12">
                                  <div className="col-12">
                                    <DynamicFilterSelect
                                      label="Generated By:"
                                      onChange={(e) => {
                                        setFilters({
                                          ...filters,
                                          generatedBy: e.target.value,
                                        });
                                      }}
                                      value={filters.generatedBy}
                                    >
                                      <option value="">select all</option>
                                      {generatedBy &&
                                        generatedBy?.map((lead, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={lead?.id}
                                            >
                                              {lead?.userName}
                                            </option>
                                          );
                                        })}
                                    </DynamicFilterSelect>
                                  </div>
                                </div>
                              )}

                              <div className="col-12">
                                <div className="row mt-2">
                                  <div className="col-6">
                                    <button
                                      onClick={() => setRefresh(!refresh)}
                                      className="btn btn-success w-100"
                                    >
                                      Apply Filter
                                    </button>
                                  </div>
                                  <div className="col-6">
                                    <button
                                      onClick={() => {
                                        setFilters({
                                          startdate: "",
                                          enddate: "",
                                          name: "",
                                          generatedBy: "",
                                        });
                                        setRefresh(!refresh);
                                      }}
                                      className="btn btn-secondary w-100"
                                    >
                                      Reset Filter
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="accordion-body d-none d-md-block">
                          <div className="row">
                            <h3>Filter result</h3>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Start Date:"
                                value={filters.startdate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="End Date:"
                                value={filters.enddate}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                }
                                type="date"
                              />
                            </div>
                            <div className="col-12">
                              <DynamicFilterInput
                                label="Search name/phone/orderId/email:"
                                value={filters.name}
                                onChange={(e) =>
                                  setFilters({
                                    ...filters,
                                    name: e.target.value,
                                  })
                                }
                                placeholder="search name..."
                              />
                            </div>

                            {(userData?.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              userData?.Role ===
                                process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                              userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Status:"
                                    onChange={(e) =>
                                      setFilters({
                                        ...filters,
                                        status: e.target.value,
                                      })
                                    }
                                    value={filters.status}
                                  >
                                    <option value="">select all</option>
                                    <option value="upcomingInspection">
                                      Upcoming Inspection
                                    </option>
                                    <option value="requestedSI">
                                      Requested SI Schedules
                                    </option>
                                    <option value="siteInspectionCompleted">
                                      Completed Site Inspection
                                    </option>
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                            )}
                            {(userData?.Role ===
                              process.env.REACT_APP_ROLE_ADMIN_S ||
                              userData?.Role ===
                                process.env.REACT_APP_ROLE_SALLE_ADMIN ||
                              userData?.Role ===
                                process.env.REACT_APP_ROLE_ADMIN) && (
                              <div className="col-12">
                                <div className="col-12">
                                  <DynamicFilterSelect
                                    label="Generated By:"
                                    onChange={(e) => {
                                      setFilters({
                                        ...filters,
                                        generatedBy: e.target.value,
                                      });
                                    }}
                                    value={filters.generatedBy}
                                  >
                                    <option value="">select all</option>
                                    {generatedBy &&
                                      generatedBy?.map((lead, index) => {
                                        return (
                                          <option key={index} value={lead?.id}>
                                            {lead?.userName}
                                          </option>
                                        );
                                      })}
                                  </DynamicFilterSelect>
                                </div>
                              </div>
                            )}

                            <div className="col-12">
                              <div className="row mt-2">
                                <div className="col-6">
                                  <button
                                    onClick={() => setRefresh(!refresh)}
                                    className="btn btn-success w-100"
                                  >
                                    Apply Filter
                                  </button>
                                </div>
                                <div className="col-6">
                                  <button
                                    onClick={() => {
                                      setFilters({
                                        startdate: "",
                                        enddate: "",
                                        name: "",
                                        generatedBy: "",
                                      });
                                      setRefresh(!refresh);
                                    }}
                                    className="btn btn-secondary w-100"
                                  >
                                    Reset Filter
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-sm-12 py-2">
                  <div className="card">
                    <SIschedulesTables
                      data={data ?? data}
                      currentPage={page}
                      itemsPerPage={50}
                    />
                    <div className="btn-list justify-content-center">
                      <div className="d-lg-none d-md-none mt-3 mb-3">
                        <button
                          className="btn btn-primary d-flex align-items-center"
                          onClick={() =>
                            (window.location.href =
                              "/schedule-site-inspection-by-sales")
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon me-1"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 5l0 14" />
                            <path d="M5 12l14 0" />
                          </svg>
                          New SI Schedule
                        </button>
                      </div>
                    </div>

                    <Pagination
                      page={page}
                      setPage={setPage}
                      totalPages={totalPages}
                      pageDatalength={data?.siteInspectionUpdatesCount?.length}
                      showPage={showPage}
                      setShowPage={setShowPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default SiSchedules;
